const parseDDMM = (DDMM) => {
	const dateMonthRegex = /^(0[1-9]|[12][0-9]|3[01])[-/.]*(0[1-9]|1[012])$/;
	try {
		const matches = DDMM.match(dateMonthRegex);
		const day = parseInt(matches[1]);
		const month = parseInt(matches[2]);
		return { month, day };
	} catch (error) {
		return;
	}
};

export const isFirstDateGreater = (fromDate, toDate) => {
	try {
		const from = parseDDMM(fromDate);
		const to = parseDDMM(toDate);

		if (from.month > to.month) {
			return true;
		} else if (from.month === to.month) {
			return from.day > to.day;
		} else if (from.month < to.month) {
			return false;
		}
	} catch (error) {
		return false;
	}
};

export const regex = (expr) => (testValue) => {
	const re = new RegExp(expr, 'g');
	return re.test(testValue, 'g');
};

export const validFieldAsterisk =
	(maxNumOfAsterisks = 1) =>
	(value) => {
		const valueArray = value.split('');
		const asterisksArrayFiltered = valueArray.filter((item) => item === '*');

		return asterisksArrayFiltered.length <= maxNumOfAsterisks;
	};

export const validFirstThreeLettersOfAsterisk = (value) => {
	// no asterisk in first 3 letters
	const part3 = value.substring(0, 3);
	if (part3.indexOf('*') !== -1) {
		return false;
	}
	return true;
};
